import { SaveAs } from '@mui/icons-material'
import { FormControlLabel, Switch } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';

function EditP() {
    const { SKU } = useParams();
    const navigate = useNavigate();
    const {profile} = useContext(AuthContext);
    const [single, setSingle] = useState({});
    const [categories, setCategories] = useState([]);
    const [markas, setMarkas] = useState([]);
    const [sellers, setSellers] = useState([]);
    const [loading, setLoading] = useState(true);
    single.username = profile.username;
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setSingle((prev) => {
            if (name === "Parent_id") {
                const firstSubCategory = categories.find(category => category.parent_id == value);
                return {
                    ...prev,
                    [name]: value,
                    Category_id: firstSubCategory ? firstSubCategory.id : "",
                };
            }
            return {
                ...prev,
                [name]: value, // Digər sahələr üçün standart dəyişiklik
            };
        });

        console.log(single)
    };
    const handleSwitchChange = (e) => {
        const { checked } = e.target;

        setSingle((prev) => ({
            ...prev,
            auto_update: checked ? 1 : 0, // Checked - 1, Unchecked - 0
        }));
        console.log(single);
    };

    const handleSave = async () => {
        try {
            const response = await fetch('https://elnaf.fi/apiElnaf/api/editProduct.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(single), // `single` state-dən məlumatları göndər
            });
            const result = await response.json();
            if (result.status === 'success') {
                alert('Product updated successfully!');
                navigate('/products');
            } else {
                alert('Error: ' + result.message);
            }
        } catch (error) {
            console.error('Error updating product:', error);
        }
    };

    useEffect(() => {
        const fetchProductDetails = async () => {
            try {
                const response = await fetch(`https://elnaf.fi/apiElnaf/api/productAdmin.php?sku=${SKU}&lang=${'en'}`);
                const data = await response.json();
                setSingle(data.product[0]);
                const responseC = await fetch(`https://elnaf.fi/apiElnaf/api/allCategory.php`);
                const dataC = await responseC.json();
                setCategories(dataC)
                const responseM = await fetch(`https://elnaf.fi/apiElnaf/api/allMarka.php`);
                const dataM = await responseM.json();
                setMarkas(dataM)
                const responseS = await fetch(`https://elnaf.fi/apiElnaf/api/allSellers.php`);
                const dataS = await responseS.json();
                setSellers(dataS)

            } catch (err) {

            } finally {
                setLoading(false);
            }
        };

        fetchProductDetails();
        if (!single) {
            navigate('/notFound');
        }
    }, [SKU]);
    return (
        <div className="row">
            {single &&

                <div className="col-xl-12">
                    <div className="card custom-card">
                        <div className="p-3 border-bottom border-top border-block-end-dashed tab-content">
                            <div className="tab-pane show active p-0 border-0" id="account-pane" role="tabpanel" aria-labelledby="account" tabIndex={0}>
                                <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-1">
                                    <div className="fw-semibold d-block fs-15">SKU : {single.SKU}</div>
                                    <div>
                                        <FormControlLabel control={<Switch checked={single.auto_update == 1} onChange={handleSwitchChange} />} label="Auto update" />
                                    </div>
                                </div>
                                <div className="row gy-3">
                                    <div className="col-xl-6">
                                        <label htmlFor="MARKA_ID" className="form-label">Marka</label>
                                        <select onChange={handleInputChange} className="form-control" data-trigger name="MARKA_ID" >
                                            {markas && markas.map(marka => (
                                                <option key={marka.id} value={marka.id}>{marka.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-xl-6">
                                        <label htmlFor="seller" className="form-label">Seller</label>
                                        <select onChange={handleInputChange} value={single.seller_id} className="form-control" data-trigger name="seller" >
                                            {sellers && sellers.map(seller => (

                                                <option value={seller.id}>{seller.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-xl-6">
                                        <label htmlFor="descriptionEn" className="form-label">Description EN</label>
                                        <input onChange={handleInputChange} type="text" className="form-control" name="Description_EN" placeholder="Description EN" value={single.Description_EN} />
                                    </div>
                                    <div className="col-xl-6">
                                        <label htmlFor="descriptionFin" className="form-label">Description FIN</label>
                                        <input onChange={handleInputChange} type="text" className="form-control" name="Description_FIN" placeholder="Description FIN" value={single.Description_FIN} />
                                    </div>
                                    <div className="col-xl-6">
                                        <label htmlFor="product-category-add1" className="form-label">Category</label>
                                        <select onChange={handleInputChange} value={single.Parent_id} className="form-control" data-trigger name="Parent_id">
                                            {categories && categories
                                                .filter(category => category.parent_id == 0)
                                                .map(category => (
                                                    <option key={category.id} value={category.id}>
                                                        {category.name_en}
                                                    </option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                    <div className="col-xl-6">
                                        <label htmlFor="Category_id" className="form-label">Sub Category</label>
                                        <select onChange={handleInputChange} value={single.Category_id} className="form-control" data-trigger name="Category_id">
                                            {categories && categories
                                                .filter(category => category.parent_id == single.Parent_id)
                                                .map(category => (
                                                    <option key={category.id} value={category.id}>
                                                        {category.name_en}
                                                    </option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                    <div className="col-xl-6">
                                        <label htmlFor="Foto" className="form-label">Foto Url</label>
                                        <input onChange={handleInputChange} type="text" className="form-control" name="Foto" placeholder="Foto Url" value={single.Foto} />
                                        <img src={single.Foto} width={40} height={40} alt="" />
                                    </div>
                                    <div className="col-xl-6">
                                        <label htmlFor="pdf" className="form-label">PDF URL</label>
                                        <input onChange={handleInputChange} type="text" className="form-control" name="pdf" placeholder="PDF Url" value={single.pdf} />
                                    </div>
                                    <div className="col-xl-6">
                                        <label htmlFor="KG" className="form-label">Weight (kg)</label>
                                        <input onChange={handleInputChange} type="number" className="form-control" value={single.KG} name="KG" placeholder="Weight" />
                                    </div>
                                    <div className="col-xl-6">
                                        <label htmlFor="stock" className="form-label">Stock</label>
                                        <input onChange={handleInputChange} type="number" className="form-control" name="stock" placeholder="Stock" value={single.stock} />
                                    </div>
                                    <div className="col-xl-6">
                                        <label htmlFor="Price" className="form-label">Price €</label>
                                        <input onChange={handleInputChange} type="number" className="form-control" value={single.Price} name="Price" placeholder="Price" />
                                    </div>
                                    <div className="col-xl-6">
                                        <label htmlFor="coefficient" className="form-label">Coefficient</label>
                                        <input onChange={handleInputChange} type="number" className="form-control" value={single.coefficient} name="coefficient" placeholder="coefficient" />
                                    </div>
                                    <div className="col-xl-6">
                                        <label htmlFor="result" className="form-label">Site Price </label>
                                        <input type="number" className="form-control" value={parseFloat((single.coefficient * single.Price).toFixed(2))} name="result" placeholder="Result" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-footer border-top-0">
                            <div className="btn-list float-end">
                                <button className="btn btn-primary" onClick={handleSave}>Save Product<SaveAs className="bi bi-download ms-2" /></button>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>

    )
}

export default EditP